// extracted by mini-css-extract-plugin
export default {"tabs":"TabList_tabs__FzZuR","tab":"TabList_tab__NTZYq","active":"TabList_active__yBi3u"};